export default {
  coachtable: [],
  coachannounce: {},
  coachform: {},
  coachsession: [],
  borach: [],
  borach_details: {},
};
